<script setup lang="ts">
	import { computed } from 'vue'

	import StyledAlert from '@/components/StyledAlert.vue'

	import { formatProviderDeadline } from '../utils/hotelDates'

	interface Props {
		deadline: string
		internalDeadline?: string
		isInternal?: boolean
	}

	interface Dates {
		main: string | undefined
		secondary: string | undefined
	}

	const props = defineProps<Props>()
	const dates = computed(() => {
		const { isInternal, internalDeadline, deadline } = props
		const draft: Dates = {
			main: undefined,
			secondary: undefined,
		}

		// `formatProviderDeadline` en vez de moment: la hora límite (23:59) es justo lo que
		// decide si hay penalización, y moment además convertía a la zona del navegador,
		// corriendo el día para quien abriera la app fuera de México.
		const sinLimite =
			'Una vez confirmada esta reserva, ya no se aceptarán cambios o cancelaciones.'

		if (isInternal) {
			draft.main =
				internalDeadline ? formatProviderDeadline(internalDeadline) : sinLimite
			draft.secondary = deadline ? formatProviderDeadline(deadline) : sinLimite
		} else {
			draft.main = deadline ? formatProviderDeadline(deadline) : sinLimite
		}

		return draft
	})
</script>

<template>
	<div class="flex flex-col gap-2">
		<div class="flex flex-wrap justify-between gap-2">
			<p
				class="w-fit text-sm font-semibold text-gray-600"
				v-if="deadline"
			>
				Fecha límite de cancelación:
			</p>
			<p
				class="w-fit text-sm fomt-semibold text-gray-500"
				:class="deadline ? 'text-gray-500' : 'text-red-500 font-bold'"
			>
				{{ !isInternal ? dates.main : dates.secondary }}
			</p>
		</div>

		<StyledAlert
			v-if="isInternal && deadline"
			class="!p-2 h-16"
			type="Info"
			:hide-nav="true"
		>
			<template #alert>
				<p class="text-sm">
					Esta fecha de cancelación es la que se encentra en el globalizador
					<span class="text-sm underline underline-offset-2">{{
						dates.main
					}}</span
					>.
				</p>
			</template>
		</StyledAlert>
	</div>
</template>

<style scoped></style>
